import { colors } from "../../../styles/theme";

/**
 * Color utility functions for the Applications Overview
 * Consolidates age-based color logic and severity color mappings
 */

/**
 * Get color based on age in minutes for overview metrics.
 *
 * @param ageMinutes - Age in minutes
 * @param variant - 'value' for the metric value color, 'text' for footer text color
 * @returns Hex color string
 */
export const getAgeBasedColor = (
  ageMinutes: number,
  variant: "value" | "text"
): string => {
  const ageDays = ageMinutes / 60 / 24;

  if (variant === "value") {
    // For the main metric value and icon
    if (ageDays >= 7) return "#ff0000"; // Bright red for 7+ days
    if (ageDays >= 4) return colors.brandCoral; // Coral for 4-7 days
    if (ageDays >= 2) return colors.brandOrange; // Orange for 2-4 days
    return "#262626"; // Dark text for < 2 days
  } else {
    // For the footer text - matches the severity level
    if (ageDays >= 7) return "#ff0000"; // Bright red for 7+ days (matches value)
    if (ageDays >= 4) return colors.brandCoral; // Coral for 4-7 days (matches value)
    if (ageDays >= 2) return colors.brandOrange; // Orange for 2-4 days (matches value)
    return "#8c8c8c"; // Gray for < 2 days
  }
};

/**
 * Get colors for severity badges (critical, warning, info)
 * Used in alert badges and status indicators
 *
 * @param severity - The severity level
 * @returns Object with background and text colors
 */
export const getSeverityColor = (
  severity: "critical" | "warning" | "info" | "success"
): { bg: string; text: string } => {
  switch (severity) {
    case "critical":
      return { bg: "#fff1f0", text: "#cf1322" };
    case "warning":
      return { bg: "#fffbe6", text: "#d48806" };
    case "info":
      return { bg: "#e6f7f5", text: "#2d8b7f" };
    case "success":
      return { bg: "#f6ffed", text: "#52c41a" };
  }
};
